import {
  css,
  BottomNavigation as MuiBottomNavigation,
  BottomNavigationAction as MuiBottomNavigationAction,
  styled,
} from '@mui/material'
import { Z_INDEX_DEFAULT_VALUE } from 'redesign/shared/zIndex/constants'

// When updating the navigation bar height, please also update the height in the constants file
export const Container = styled('div')`
  z-index: ${Z_INDEX_DEFAULT_VALUE};
  display: flex;
  justify-content: center;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: max(var(--ion-safe-area-bottom), ${({ theme }) => theme.spacing(1)});
  background-color: ${({ theme }) => theme.palette.background.base};
`

export const BottomNavigation = styled(MuiBottomNavigation)`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.base};
  max-width: ${({ theme }) => theme.spacing(75)};
  padding: ${({ theme }) => theme.spacing(0, 2)};
  padding-top: ${({ theme }) => theme.spacing(1)};
  justify-content: space-around;
`

export const BottomNavigationAction = styled(MuiBottomNavigationAction, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>`
  gap: ${({ theme }) => theme.spacing(0.5)};
  min-width: 0;
  max-width: ${({ theme }) => theme.spacing(7.5)};
  border-radius: ${({ theme }) => theme.spacing(0.5)};
  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      background-color: ${theme.palette.primary.light};
    `}

  & .Mui-selected,
  & .active,
  & .MuiBottomNavigationAction-iconOnly {
    font-size: 0 !important;
    padding: unset;
  }
`
